import { legacy_createStore as createStore, applyMiddleware } from 'redux';
import { thunk } from 'redux-thunk';
import rootReducer from './reducer';
export const composedEnhancer = applyMiddleware(thunk);
export const store = createStore(rootReducer, composedEnhancer);
